// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//
import { subscribeStyles } from "@guestsupply/Overrides/Widgets/Basic/Subscribe";
import { mergeWithCss, xScreen } from "@guestsupply/XDL/Utilities";
import { css } from "styled-components";

subscribeStyles.mainGridContainer = {
    ...subscribeStyles.mainGridContainer,
    gap: 22,
};
subscribeStyles.titleGridItem = {
    width: [12, 12, 6, 5, 5],
    css: css`
        flex-direction: column;
    `,
};
subscribeStyles.titleLabel = {
    ...subscribeStyles.titleLabel,
    color: "common.ui1",
    as: "span", // as="p" wasn't used here since the p tag in the footer has custom style which will be affected here
    css: css`
        margin-bottom: 8px;
    `,
};
subscribeStyles.descriptionText = {
    color: "common.ui1",
    css: css`
        > p {
            line-height: 20px;
            font-size: 12px;
        }
    `,
};
subscribeStyles.emailGridItem = {
    width: [12, 12, 6, 7, 7],
    css: css`
        align-items: center;
    `,
};
subscribeStyles.emailTextField = {
    cssOverrides: {
        formField: css`
            margin-right: 24px;
            height: 36px;
        `,
        descriptionWrapper: css`
            &&&& {
                ${xScreen("lte", "sm")} {
                    margin-top: 0;
                }
            }
        `,
    },
};
subscribeStyles.emailButton = {
    css: css`
        width: 150px;
        min-width: 150px;
        margin-right: 12px;
        ${xScreen("lte", "md")} {
            width: 115px;
            min-width: 115px;
            margin-right: 0;
        }
    `,
};
subscribeStyles.disclaimerGridItem = {
    ...subscribeStyles.titleLabel,
    css: css`
        padding: 0;
    `,
};
